import React, { useState, useEffect, useCallback } from 'react';
import './BootSequence.css';

const BOOT_LINES = [
  { text: 'S.O.S SYSTEM BIOS v1.0.0',                              delay: 800  },
  { text: 'Copyright (C) S.O.S Operating Systems, Inc.',           delay: 1100 },
  { text: 'All Rights Reserved.',                                   delay: 1300 },
  { text: '',                                                        delay: 1500 },
  { text: 'Processor  : SeanCore\u2122 Mk.IX @ 3.14 GHz',          delay: 1700 },
  { text: 'Base Memory: 640 KB OK',                                 delay: 2000 },
  { text: 'Ext. Memory: 8,192 MB OK',                               delay: 2200 },
  { text: 'Display    : PhosphorTech GreenBeam 64',                 delay: 2500 },
  { text: '',                                                        delay: 2700 },
  { text: 'Initializing PCI bus ............................ OK',   delay: 2900 },
  { text: 'Scanning for storage devices...',                        delay: 3300 },
  { text: '',                                                        delay: 3500 },
  { text: '  \u2618  /dev/skills          [ LOADED ]',              delay: 3700 },
  { text: '  \u2618  /dev/projects        [ LOADED ]',              delay: 4000 },
  { text: '  \u2618  /dev/experience      [ LOADED ]',              delay: 4300 },
  { text: '  \u2618  /dev/contact         [ LOADED ]',              delay: 4600 },
  { text: '',                                                        delay: 4800 },
  { text: 'System integrity check ................... PASS',        delay: 5000 },
  { text: 'Loading S.O.S kernel ..................... OK',          delay: 5400 },
  { text: 'Starting process manager ................. OK',          delay: 5750 },
  { text: 'Mounting virtual filesystem .............. OK',          delay: 6100 },
  { text: 'Launching desktop environment ............ OK',          delay: 6450 },
  { text: '',                                                        delay: 6700 },
  { text: '[\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588] 100% COMPLETE', delay: 7300 },
  { text: '',                                                        delay: 7500 },
  { text: '\u2618  Welcome to S.O.S  \u2618',                       delay: 7800 },
];

const BootSequence = ({ onComplete }) => {
  const [visibleLines, setVisibleLines] = useState([]);
  const [phase, setPhase] = useState('power-on');

  const exit = useCallback(() => {
    setPhase('exiting');
    setTimeout(onComplete, 750);
  }, [onComplete]);

  useEffect(() => {
    const t = setTimeout(() => setPhase('booting'), 750);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (phase !== 'booting') return;

    const timers = BOOT_LINES.map((line) =>
      setTimeout(
        () => setVisibleLines((prev) => [...prev, line.text]),
        line.delay
      )
    );

    const completeTimer = setTimeout(() => setPhase('complete'), 8400);

    return () => {
      timers.forEach(clearTimeout);
      clearTimeout(completeTimer);
    };
  }, [phase]);

  useEffect(() => {
    if (phase !== 'complete') return;
    const t = setTimeout(exit, 2200);
    return () => clearTimeout(t);
  }, [phase, exit]);

  return (
    <div
      className={`boot-screen ${phase}`}
      onClick={phase === 'complete' ? exit : undefined}
    >
      <div className="boot-crt-vignette" />
      <div className="boot-scanlines" />
      <div className="boot-content">
        {visibleLines.map((line, i) => {
          const isTitle = line.includes('Welcome to S.O.S');
          return (
            <div key={i} className={`boot-line${isTitle ? ' boot-welcome' : ''}`}>
              {line || '\u00A0'}
            </div>
          );
        })}
        {phase === 'booting' && (
          <span className="boot-cursor">█</span>
        )}
        {phase === 'complete' && (
          <div className="boot-prompt">[ CLICK TO CONTINUE ]</div>
        )}
      </div>
    </div>
  );
};

export default BootSequence;
